import WishListIcon from '@/components/account/wishList/WishListIcon';
import { ProductModel } from '@/models';
import styles from './HeaderProductImage.module.scss';

type HeaderProductImageProps = {
	product: ProductModel;
};

const HeaderProductImage = ({ product }: HeaderProductImageProps) => {
	return (
		<div className={styles.container}>
			<WishListIcon product={product} />
		</div>
	);
};

export default HeaderProductImage;
